export function emailValidation(value: string): {invalidEmail?: boolean} {

    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!regex.test(value)) {
        return { invalidEmail: true };
    }

    return {};
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./~/@teamui/validation/validation/email.ts
 **/